import assert from '@/sui/tools/assert'
import denominatorsData from '@/sui/data/sheets/edit/denominators'
import toolsUsageData from '@/sui/data/sheets/edit/toolsUsage'
import validator from '@/sui/components/sheet/validate/impl/validator'

const sc = {
  errorsMsg: {
    persist: `Si le problème persiste, merci de contacter un administrateur via le formulaire de contact.`,
    data: `Erreur interne lors de la récupération des données de la fiche `,
    valid: `Impossible de valider la fiche sur le serveur`
  }
}

const implData = {
  denominators: {
    sheetData: denominatorsData,
    sheetName: 'établissement',
    path: 'denominators'
  },

  toolsUsage: {
    sheetData: toolsUsageData,
    sheetName: 'utilisation des outils',
    path: 'toolsUsage'
  }
}

function getStepsAndTitle (sheetType) {
  assert.isString(sheetType)

  const d = implData[sheetType]
  assert.notNull(d)

  return {
    title: `Fiche ${d.sheetName}`,
    steps: [
      {
        promise: true,
        timeout: 10000,
        error: null,
        title: 'Récupération des données',
        progress: {
          value: 0
        },
        run: function (vm, data, iteration) {
          this.progress.value = 100
          const request = {
            s: vm.surveillance.id,
            y: vm.surveillance.year
          }
          return vm.$store.dispatch(`${d.path}/edit`, request).then(
            (response) => {
              return {
                end: true,
                success: response.data.err == null,
                error: `${sc.errorsMsg.data} ${d.sheetName}. ${sc.errorsMsg.persist}`
              }
            }
          )
        },

        setError: function () {
          this.error = `${sc.errorsMsg.data} ${d.sheetName}, merci de vérifier votre
connexion internet avant de réessayer. ${sc.errorsMsg.persist}`
        }
      },

      {
        title: 'Vérification des champs',
        progress: {
          value: 0
        },
        run: function (vm, data, iteration) {
          this.progress.value = (iteration > 3) ? 100 : 30 * iteration
          if (this.progress.value === 100) {
            data.sheet = vm.$store.getters[`${d.path}/edit`].sheet
            const result = validator.checkValidity(
              vm, d.sheetData[`${vm.surveillance.year}`], data.sheet
            )
            return {
              end: true,
              success: result.errors === 0 && result.missing === 0,
              error: this.buildError(result)
            }
          }

          return { end: false }
        },

        buildError: function (result) {
          const errors = result.errors === 0 ? ''
            : result.errors === 1
              ? `1 champ comporte une erreur`
              : `${result.errors} champs comportent des erreurs`
          const missing = result.missing === 0 ? ''
            : result.missing === 1
              ? `1 champ n'est pas renseigné`
              : `${result.missing} champs ne sont pas renseignés`

          const link = (errors !== '' && missing !== '') ? ' et ' : ''
          return `Merci de corriger la ${d.sheetName} : ${errors}${link}${missing}.`
        },

        setError: function () {
          this.error =
            `Erreur interne lors de la vérification de la ${d.sheetName}. ${sc.errorsMsg.persist}`
        }
      },
      {
        title: 'Validation de la fiche sur le serveur',
        timeout: 10000,
        promise: true,
        progress: {
          value: 0
        },
        run: function (vm, data, iteration) {
          this.progress.value = 100
          const surv = vm.surveillance
          const sh = data.sheet
          const payload =
                d.path === implData.denominators.path
                  ? { sh: { id: sh.id, ver: sh.v }, s: 'valid' }
                  : { y: surv.year, s: surv.id, st: 'valid' }

          return vm.$store.dispatch(
            `${d.path}/status`,
            payload
          ).then(
            (response) => {
              const { err } = response.data
              return {
                end: true,
                success: err == null,
                error: `${sc.errorsMsg.valid}, merci de recharger la page avant de réessayer.
${sc.errorsMsg.persist}`
              }
            }
          )
        },

        setError: function () {
          this.error = `${sc.errorsMsg.valid}. ${sc.errorsMsg.persist}`
        }
      }
    ]
  }
}

export default {
  getStepsAndTitle
}
